import type { GAD7Schema } from 'src/participantHistory/GAD7Fields'
import type { PHQ9Schema } from 'src/participantHistory/PHQ9Fields'

export const DUMMY_PHQ9: PHQ9Schema = {
  PHQ9_QUESTION_1: 1,
  PHQ9_QUESTION_2: 2,
  PHQ9_QUESTION_3: 0,
  PHQ9_QUESTION_4: 3,
  PHQ9_QUESTION_5: 1,
  PHQ9_QUESTION_6: 0,
  PHQ9_QUESTION_7: 2,
  PHQ9_QUESTION_8: 1,
  PHQ9_QUESTION_9: 0,
  PHQ9_SCORE: 10,
}

export const DUMMY_GAD7: GAD7Schema = {
  GAD7_QUESTION_1: 1,
  GAD7_QUESTION_2: 0,
  GAD7_QUESTION_3: 2,
  GAD7_QUESTION_4: 1,
  GAD7_QUESTION_5: 3,
  GAD7_QUESTION_6: 0,
  GAD7_QUESTION_7: 1,
  GAD7_SCORE: 8,
}
